import React from "react";
import style from "./index.module.scss";
import classNames from "classnames";
import { useHistory, useLocation } from "react-router-dom";

interface StaticsProps {
    current: string;
    onChange: (current: string) => void; //改变当前状态
    allCounts: number; //总组数
    noJudgeCounts: number; //未批阅
    judgeCounts: number; //已批阅
    noJoinInCounts: number; //未参与
}

export default function Statics({
    current,
    onChange,
    allCounts,
    noJudgeCounts,
    judgeCounts,
    noJoinInCounts
}: StaticsProps) {
    const history = useHistory();
    const { pathname } = useLocation();

    function handleClick(params: string) {
        onChange(params);
        history.replace(`${pathname}?status=${params}`);
    }

    return (
        <div className={style.root}>
            <div
                className={classNames(style.statics, {
                    [style.active]: current === "all"
                })}
                onClick={() => handleClick("all")}>
                <em>{allCounts}</em>总组数
            </div>
            <div
                className={classNames(style.statics, {
                    [style.active]: current === "judged"
                })}
                onClick={() => handleClick("judged")}>
                <em>{judgeCounts}</em>已批阅
            </div>
            <div
                className={classNames(style.statics, {
                    [style.active]: current === "noJudge"
                })}
                onClick={() => handleClick("noJudge")}>
                <em>{noJudgeCounts}</em>待批阅
            </div>
            <div
                className={classNames(style.statics, {
                    [style.active]: current === "noJoinIn"
                })}
                onClick={() => handleClick("noJoinIn")}>
                <em>{noJoinInCounts}</em>未参与
            </div>
        </div>
    );
}
